module.exports = __webpack_public_path__ + "img/fi-rr-user-time.67592cef.svg";